import dynamic from "next/dynamic";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CompanyWrapper from "../../components/company/CompanyWrapper";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import SharedCompanyHeader from "../../components/shared/SharedHeader/SharedCompanyHeader/SharedCompanyHeader";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import {
  getCompanyJobsWithoutRedux,
  getCompanyWithoutRedux,
} from "../../redux/actions/company_action";
import CDPUploadResumeFloating from "../../components/shared/UploadResumeFloating/wrappers/CDPUploadResumeFloating";

const Toolbar = dynamic(() => import("@mui/material/Toolbar"));
const SharedCollapsibleFooter = dynamic(
  () =>
    import(
      "../../components/shared/SharedCollapsibleFooter/SharedCollapsibleFooter"
    )
);

function CompanyProfile({ company, companyJobs }) {
  const staticCompanyJobs = companyJobs;
  const { t } = useTranslation();

  return (
    <Fragment>
      <div style={{ backgroundColor: "#f7f7f7" }}>
      <SharedCompanyHeader company={company} />
      <ToResolveClassNameError>
        <SharedNavbar2
          page="company-list-page"
          breadcrumbItems={[
            { label: t("nav.companies"), href: "/companies" },
            { label: company?.name },
          ]}
        />
      </ToResolveClassNameError>
      <Toolbar
        sx={{
          "@media(min-width: 1280px)": {
            // minHeight: "64px",
            minHeight: "104px !important",
          },
          "@media(max-width: 1279px)": {
            // minHeight: "52px",
            minHeight: "92px !important",
          },
          "@media(max-width: 639px)": {
            // minHeight: "60px",
            minHeight: "100px !important",
          },
        }}
      />
      <CompanyWrapper company={company} staticCompanyJobs={staticCompanyJobs} />
      <ToResolveClassNameError>
        <SharedCollapsibleFooter />
      </ToResolveClassNameError>
      <CDPUploadResumeFloating />
      </div>
    </Fragment>
  );
}

export async function getStaticPaths() {
  let paths = [];

  return {
    paths: paths,
    fallback: "blocking",
  };
}

export async function getStaticProps({ params }) {
  // Get static company
  let param = {
    companyId: params.id,
  };

  const company = await getCompanyWithoutRedux(param);
  const companyJobs = await getCompanyJobsWithoutRedux({
    companyId: company.id,
  });

  if (company?.hide) {
    return {
      redirect: {
        permanent: false,
        destination: "/companies",
      },
      revalidate: 480,
    };
  }

  if (company?.companyNotFound) {
    return {
      notFound: true,
      revalidate: 480,
    };
  }

  return {
    props: {
      id: params.id,
      company: company,
      companyJobs: companyJobs,
    },
    revalidate: 480,
  };
}

export default CompanyProfile;
